module.exports = __webpack_public_path__ + "static/media/532JamesPBrawleyDrNW_2018-06-12_174.c901dede.jpg";